import React from "react";

const LoadSpinner = ({show = true}) => {
    return (show && <div className="sl-flex sl-align-center sl-justify-center sl-grow-1 sl-w-full">
        <div className="sl-loader sl-m-auto"/>
    </div>);
};

export default LoadSpinner;
